module.exports = __webpack_public_path__ + "media/product/f-2-fa84857b.png";